import { resolveAppUrl } from '@shared/utils/resolveAppUrl';

import { addDefaultUtmParams } from '../../utils/addDefaultUtmParams';

export interface ListItem {
  id: string;
  href: string;
  label: string;
  src: string;
}

export const appsAndGamesListConfig: ListItem[] = [
  {
    id: 'pancakeSwap',
    href: addDefaultUtmParams(resolveAppUrl('pancakeswap', undefined, true)),
    label: 'PancakeSwap',
    src: '/magicsquare/landing/appsAndGamesLogo/PancakeSwap.png',
  },
  {
    id: 'kraken',
    href: addDefaultUtmParams(resolveAppUrl('kraken', undefined, true)),
    label: 'Kraken',
    src: '/magicsquare/landing/appsAndGamesLogo/Kraken.png',
  },
  {
    id: '1inch',
    href: addDefaultUtmParams(resolveAppUrl('1inch', undefined, true)),
    label: '1inch',
    src: '/magicsquare/landing/appsAndGamesLogo/1inch.png',
  },
  {
    id: 'arkham',
    href: addDefaultUtmParams(resolveAppUrl('arkham', undefined, true)),
    label: 'Arkham',
    src: '/magicsquare/landing/appsAndGamesLogo/Arkham.png',
  },
  {
    id: 'mantra',
    href: addDefaultUtmParams(resolveAppUrl('mantra', undefined, true)),
    label: 'MANTRA',
    src: '/magicsquare/landing/appsAndGamesLogo/Mantra.png',
  },
  {
    id: 'okxDex',
    href: addDefaultUtmParams(resolveAppUrl('okx-dex', undefined, true)),
    label: 'OKX Dex',
    src: '/magicsquare/landing/appsAndGamesLogo/OKXDex.png',
  },
  {
    id: 'anichess',
    href: addDefaultUtmParams(resolveAppUrl('anichess', undefined, true)),
    label: 'Anichess',
    src: '/magicsquare/landing/appsAndGamesLogo/Anichess.png',
  },
  {
    id: 'heroesOfMavia',
    href: addDefaultUtmParams(resolveAppUrl('heroes-of-mavia', undefined, true)),
    label: 'Heroes Of Mavia',
    src: '/magicsquare/landing/appsAndGamesLogo/HeroesOfMavia.png',
  },
  {
    id: 'mobox',
    href: addDefaultUtmParams(resolveAppUrl('mobox', undefined, true)),
    label: 'MOBOX',
    src: '/magicsquare/landing/appsAndGamesLogo/Mobox.png',
  },
  {
    id: 'blockLords',
    href: addDefaultUtmParams(resolveAppUrl('blocklords', undefined, true)),
    label: 'BLOCKLORDS',
    src: '/magicsquare/landing/appsAndGamesLogo/BlockLords.png',
  },
  {
    id: 'galaGames',
    href: addDefaultUtmParams(resolveAppUrl('gala-games', undefined, true)),
    label: 'Gala Games',
    src: '/magicsquare/landing/appsAndGamesLogo/GalaGames.png',
  },
  {
    id: 'cookie3',
    href: addDefaultUtmParams(resolveAppUrl('cookie3', undefined, true)),
    label: 'Cookie3',
    src: '/magicsquare/landing/appsAndGamesLogo/Cookie3.png',
  },
];
